module.exports = __webpack_public_path__ + "static/media/sorting_icon_default.e6ff8f71.svg";